// Mirror of CommonPdfHeader.jsx as a docx section Header (repeats on every page).
// Right-aligned logo + "X years experience" line in grey.

import { AlignmentType, Header, ImageRun } from "docx";
import { calculateTotalExperienceDuration } from "../../../../utils/calculateDatesDifference";
import { scaleToHeight, scaleToWidth } from "../../shared/wordImage";
import { para, run } from "../../shared/wordHelpers";
import { FONT_ARIAL, HEADER_GREY } from "../../shared/wordTheme";

export function buildCommonHeader( { data, props, translations, logoImage } ) {
    const { experiences, totalExperienceDuration } = data;
    const { isLusis } = props;

    const {
        years: experienceYears,
        months: experienceMonths,
    } = calculateTotalExperienceDuration( experiences, totalExperienceDuration );

    const template = translations?.pdf?.workExperienceTemplate ?? "";
    const experienceText = `${ translations?.pdf?.workExperienceLabel ?? "" } ${ template
        .replace( "{years}", experienceYears )
        .replace( "{months}", experienceMonths ) }`.trim();

    const children = [];
    if ( logoImage ) {
        const size = isLusis ? scaleToHeight( logoImage, 75 ) : scaleToWidth( logoImage, 60 );
        children.push( para(
            new ImageRun( { data: logoImage.data, transformation: size } ),
            { alignment: AlignmentType.RIGHT, spacing: { after: 0 } }
        ) );
    }
    children.push( para(
        run( experienceText, { pt: 8, color: HEADER_GREY, font: FONT_ARIAL } ),
        { alignment: AlignmentType.RIGHT, spacing: { after: 0 } }
    ) );

    return new Header( { children } );
}
